import { Container } from "react-bootstrap";
import NavBar from "../NavBar/NavBar";
import "../../styles/UserDashboard.css";

const UserDashboard = ({ auth, onLogout }) => {
    return (
        <>
            <NavBar auth={auth} onLogout={onLogout} />
            <div className="animation-container">
                <div className="animate-circle circle-1"></div>
                <div className="animate-circle circle-2"></div>
                <div className="animate-circle circle-3"></div>
                <div className="animate-circle circle-4"></div>
                <div className="animate-circle circle-5"></div>

                <Container fluid className="px-md-5 d-flex flex-column justify-content-center align-items-center content-area" style={{ minHeight: "calc(100vh - 56px)" }}>
                    <div className="p-4 p-md-5 rounded-5 text-center animate-float">
                        <h1 className="display-6 mb-4 mt-4 animate-text">
                            Welcome back, {auth.user?.name || "User"}!{" "}
                            <span role="img" aria-label="sparkles">
                                ✨
                            </span>
                        </h1>
                        <p className="lead mb-4 animate-text delay-1"> We're glad to see you again. </p>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default UserDashboard;